import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-icon",
  "use": "icon-plus-icon-usage",
  "viewBox": "0 0 18.02 18.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.02 18.02\" id=\"icon-plus-icon\"><path d=\"m10.73 9.01 6.94-6.94A1.217 1.217 0 1 0 16 .3l-.05.05-6.94 6.94L2.07.36C1.6-.11.83-.11.35.36c-.47.47-.47 1.24 0 1.72l6.94 6.94-6.93 6.93c-.47.47-.47 1.24 0 1.72.47.47 1.24.47 1.72 0l6.94-6.94 6.94 6.94a1.217 1.217 0 0 0 1.72-1.72l-6.94-6.94Z\" data-name=\"Path 534\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol